export default __webpack_public_path__ + "fd2639b3efe1e78290410df0222e602c.svg";